import { render, staticRenderFns } from "./priceTotal.vue?vue&type=template&id=9948501e&scoped=true"
import script from "./priceTotal.vue?vue&type=script&lang=js"
export * from "./priceTotal.vue?vue&type=script&lang=js"
import style0 from "./priceTotal.vue?vue&type=style&index=0&id=9948501e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9948501e",
  null
  
)

export default component.exports